import React, { useEffect, useState } from 'react';
import { Row, Col, Card, Space, DatePicker, Drawer, Form, Input, Select, Radio, message, Modal, Pagination, Tabs } from 'antd';
import { Table, Button } from 'antd';
import BreadcrumbCustom from '../../components/widget/BreadcrumbCustom';
import { DownOutlined, ExclamationCircleOutlined, MinusCircleOutlined, PlusOutlined } from '@ant-design/icons';
import moment from 'moment';
import CardList from './CardList';
import PunchRecordList from './PunchRecordList';
import CourseDefinitionList from './CourseDefinitionList';
import CardDefinitionList from './CardDefinitionList';

const { TabPane } = Tabs;


const CardDefinitionView = (props: any) => {

  const [currentTabKey, setCurrentTabKey] = useState<number>(1);
  const [cardDefinitionVisible, setCardDefinitionVisible] = useState(false);
  const [courseDefinitionVisible, setCourseDefinitionVisible] = useState(false);

  const tabExtraContent = () => {
    switch (currentTabKey) {
      case 1:
        return <Button type="primary" style={{ marginRight: '20px' }} onClick={() => {
          setCardDefinitionVisible(true);
        }} icon={<PlusOutlined />}>
          新增课程包
        </Button>
      case 2:
        return <Button type="primary" style={{ marginRight: '20px' }} onClick={() => {
          setCourseDefinitionVisible(true);
        }} icon={<PlusOutlined />}>
          新增课程
        </Button>
      default:
        return <></>
    }
  }

  function onTabChange(key: any) {
    console.log(key);
    setCurrentTabKey(Number(key));
  }

  return (
    <div className="gutter-example">
      <BreadcrumbCustom breads={['课程包管理']} />
      <Row gutter={16}>
        <Col className="gutter-row" md={24}>
          <div className="gutter-box">
            <Tabs defaultActiveKey="1" onChange={onTabChange} style={{ marginBottom: 32 }}
              tabBarExtraContent={tabExtraContent()}>
              <TabPane tab="课程包管理" key="1">
                <CardDefinitionList
                  visible={cardDefinitionVisible}
                  setVisible={setCardDefinitionVisible}
                />
              </TabPane>
              <TabPane tab="课程定义" key="2">
                <CourseDefinitionList
                  visible={courseDefinitionVisible}
                  setVisible={setCourseDefinitionVisible}
                />
              </TabPane>
              <TabPane tab="已购课包记录" key="3">
                <CardList />
              </TabPane>
              <TabPane tab="课程打卡记录" key="4">
                <PunchRecordList />
              </TabPane>
            </Tabs>
          </div>
        </Col>
      </Row>
    </div>
  );
};

export default CardDefinitionView;
